<script setup>
import { computed } from 'vue';
import TechnicalPropertyInfo from 'components/competitor-app-v2/technical-properties/TechnicalPropertyInfo.vue';
import TechnicalPropertyTableValue from 'components/competitor-app-v2/technical-properties/TechnicalPropertyTableValue.vue';

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
});

const byApplicationType = computed(() => {
  const result = {};

  Object.values(props.data).forEach((properties) => {
    if (properties) {
      properties.forEach((property) => {
        if (!result[property.applicationType]) {
          result[property.applicationType] = {};
        }

        result[property.applicationType][property.propertyType] = property.value;
      });
    }
  });

  return result;
});

const preparedByApplicationType = computed(() => {
  if (!byApplicationType.value) {
    return null;
  }

  const result = {};

  for (const [key, value] of Object.entries(byApplicationType.value)) {
    const rowsByCode = {};

    for (const type of ['hue', 'chroma', 'lightness']) {
      if (value[type]) {
        for (const { code, value: val } of value[type]) {
          if (!rowsByCode[code]) {
            rowsByCode[code] = {
              angle: code, chroma: null, hue: null, lightness: null
            };
          }
          rowsByCode[code][type] = val;
        }
      }
    }

    const sorted = Object.values(rowsByCode).sort((a, b) => parseInt(a.angle, 10) - parseInt(b.angle, 10));

    const rows = [
      {
        isHeader: true,
        columns: ['Angle', 'h', 'C*', 'L*'],
      }
    ];
    for (const r of sorted) {
      rows.push({
        columns: [`${r.angle}°`, r.hue, r.chroma, r.lightness]
      });
    }

    result[key] = { rows };
  }

  return result;
});
</script>

<template>
  <div class="ce-technicalPropertyCard ce-technicalPropertyCard--chromaHueLightnessTable">
    <div class="flex items-center mb3">
      <TechnicalPropertyInfo
        property-type="hue" />
      &nbsp;/&nbsp;
      <TechnicalPropertyInfo
        property-type="chroma" />
      &nbsp;/&nbsp;
      <TechnicalPropertyInfo
        property-type="lightness" />
    </div>

    <div class="innerCardsWrapper">
      <TechnicalPropertyTableValue
        v-for="(values, applicationType) in preparedByApplicationType"
        :key="`chroma_hue_lightness__${applicationType}`"
        :application-type="applicationType"
        :rows="values.rows" />
    </div>
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-technicalPropertiesByMedium {
  .ce-technicalPropertiesWrapper {
    .ce-technicalPropertyCard--chromaHueLightnessTable {
      .innerCardsWrapper {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: @space-4;
      }

      @media screen and (min-width: @breakpoint-xl) {
        grid-column: span 2;
      }

      @media screen and (min-width: @breakpoint-xxl) {
        grid-column: span 3;
      }
    }
  }
}
</style>
